import { Injectable } from '@angular/core';
import { FunctionDto } from '@osos/shared/api';
import { CustomFunctionPresenterModel } from '@osos/shared/types';
import { ParserBase } from '../../bases/parser/parser-base';

@Injectable({
  providedIn: 'root',
})
export class FunctionsParserV1Service extends ParserBase<
  FunctionDto,
  CustomFunctionPresenterModel
> {
  constructor() {
    super(FunctionDto, CustomFunctionPresenterModel, 1);
  }
  getPresenterModel(model: Partial<FunctionDto>): CustomFunctionPresenterModel {
    return {
      // codeFile: model.codeFile,
      // executingEnd: model.executingEnd,
      // language: model.language,
      name: model.name,
      normalizedName: model.normalizedName,
      // scope: model.scope,
      // status: model.status,
      // type: model.type,
      id: model.id,
      parameters: model.parameters,
    };
  }
  getDataModel(presenter: CustomFunctionPresenterModel): FunctionDto {
    const model = {
      // codeFile: presenter.codeFile,
      // executingEnd: presenter.executingEnd,
      // language: presenter.language,
      name: presenter.name,
      normalizedName: presenter.normalizedName,
      parameters: presenter.parameters,
      // scope: presenter.scope,
      // type: presenter.type,
    } as FunctionDto;

    return model;
  }
}
